import React from 'react';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

export default function ProductEditorCard({ id, title, subtitle, collapsed = false, onToggle, onDragStart, onDrop, children }) {
  const draggable = Boolean(id && onDragStart && onDrop);
  const heading = <span><strong>{title}</strong>{subtitle ? <small>{subtitle}</small> : null}</span>;
  return <section className={`product-editor-card ${collapsed ? 'is-collapsed' : ''}`} draggable={draggable} onDragStart={draggable ? (event) => onDragStart(event, id) : undefined} onDragOver={draggable ? (event) => event.preventDefault() : undefined} onDrop={draggable ? (event) => onDrop(event, id) : undefined}>
    <header className="product-editor-card__header">
      {draggable ? <span className="product-editor-card__drag" title="Drag card"><DragIndicatorIcon fontSize="small" /></span> : null}
      {onToggle ? <button type="button" className="product-editor-card__heading" onClick={() => onToggle(id)}>{heading}<ExpandMoreIcon className="product-editor-card__chevron" /></button> : <div className="product-editor-card__heading product-editor-card__heading--static">{heading}</div>}
    </header>
    {!collapsed ? <div className="product-editor-card__body">{children}</div> : null}
  </section>;
}
